<template>
  <v-card-text>
    <div class="text-center py-10">
      <h3>News Radar Scoring Configuration</h3>
      <p class="mt-4">
        Cette section contiendra les options de configuration de prompts pour le
        scoring des articles de la veille globale.
      </p>
      <p>Coming soon...</p>
    </div>
  </v-card-text>
</template>

<script>
export default {
  name: "NewsRadarScoring",
};
</script>
